var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ASidebar',{attrs:{"area":"channel-upsell","enabled":_vm.enabled},on:{"beforeopen":_vm.install}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }